import { TenantEntity } from '../TenantEntity'
import { cache, cacheName } from '@/utils/cacheManager'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getOfficeById, getOfficeByUuid } from '../../../api/office'
import { getUserInfo } from '@/utils/auth'

export class Office extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId || 0
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get cityName() {
    return this._data.cityName
  }
  set cityName(cityName) {
    this._data.cityName = cityName
  }
  get chineseAddress() {
    return this._data.chineseAddress
  }
  set chineseAddress(chineseAddress) {
    this._data.chineseAddress = chineseAddress
  }
  get seaAddressLine1() {
    return this._data.seaAddressLine1
  }
  set seaAddressLine1(seaAddressLine1) {
    this._data.seaAddressLine1 = seaAddressLine1
  }
  get seaAddressLine2() {
    return this._data.seaAddressLine2
  }
  set seaAddressLine2(seaAddressLine2) {
    this._data.seaAddressLine2 = seaAddressLine2
  }
  get seaAddressLine3() {
    return this._data.seaAddressLine3
  }
  set seaAddressLine3(seaAddressLine3) {
    this._data.seaAddressLine3 = seaAddressLine3
  }
  get seaAddressLine4() {
    return this._data.seaAddressLine4
  }
  set seaAddressLine4(seaAddressLine4) {
    this._data.seaAddressLine4 = seaAddressLine4
  }
  get seaAddressLine5() {
    return this._data.seaAddressLine5
  }
  set seaAddressLine5(seaAddressLine5) {
    this._data.seaAddressLine5 = seaAddressLine5
  }
  get seaAddressLine6() {
    return this._data.seaAddressLine6
  }
  set seaAddressLine6(seaAddressLine6) {
    this._data.seaAddressLine6 = seaAddressLine6
  }
  get airAddressLine1() {
    return this._data.airAddressLine1
  }
  set airAddressLine1(airAddressLine1) {
    this._data.airAddressLine1 = airAddressLine1
  }
  get airAddressLine2() {
    return this._data.airAddressLine2
  }
  set airAddressLine2(airAddressLine2) {
    this._data.airAddressLine2 = airAddressLine2
  }
  get airAddressLine3() {
    return this._data.airAddressLine3
  }
  set airAddressLine3(airAddressLine3) {
    this._data.airAddressLine3 = airAddressLine3
  }
  get airAddressLine4() {
    return this._data.airAddressLine4
  }
  set airAddressLine4(airAddressLine4) {
    this._data.airAddressLine4 = airAddressLine4
  }
  get airAddressLine5() {
    return this._data.airAddressLine5
  }
  set airAddressLine5(airAddressLine5) {
    this._data.airAddressLine5 = airAddressLine5
  }
  get airAddressLine6() {
    return this._data.airAddressLine6
  }
  set airAddressLine6(airAddressLine6) {
    this._data.airAddressLine6 = airAddressLine6
  }
  get zipCode() {
    return this._data.zipCode
  }
  set zipCode(zipCode) {
    this._data.zipCode = zipCode
  }
  get phone() {
    return this._data.phone
  }
  set phone(phone) {
    this._data.phone = phone
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get airport() {
    return this._data.airport
  }
  set airport(airport) {
    this._data.airport = airport
  }
  get seaport() {
    return this._data.seaport
  }
  set seaport(seaport) {
    this._data.seaport = seaport
  }
  get rmbAccount() {
    return this._data.rmbAccount
  }
  set rmbAccount(rmbAccount) {
    this._data.rmbAccount = rmbAccount
  }
  get usdAccount() {
    return this._data.usdAccount
  }
  set usdAccount(usdAccount) {
    this._data.usdAccount = usdAccount
  }
  get taxAccount() {
    return this._data.taxAccount
  }
  set taxAccount(taxAccount) {
    this._data.taxAccount = taxAccount
  }
  get overseaAddress() {
    return this._data.overseaAddress
  }
  set overseaAddress(overseaAddress) {
    this._data.overseaAddress = overseaAddress
  }
  get localAddress() {
    return this._data.localAddress
  }
  set localAddress(localAddress) {
    this._data.localAddress = localAddress
  }
  get ediCode() {
    return this._data.ediCode
  }
  set ediCode(ediCode) {
    this._data.ediCode = ediCode
  }
  get taxRate() {
    return this._data.taxRate
  }
  set taxRate(taxRate) {
    this._data.taxRate = taxRate || 0
  }
  get invoiceTaxRate() {
    return this._data.invoiceTaxRate
  }
  set invoiceTaxRate(invoiceTaxRate) {
    this._data.invoiceTaxRate = invoiceTaxRate || 0
  }
  get clearEmail() {
    return this._data.clearEmail
  }
  set clearEmail(clearEmail) {
    this._data.clearEmail = clearEmail
  }
  get sajtInvoiceService() {
    return this._data.sajtInvoiceService
  }
  set sajtInvoiceService(sajtInvoiceService) {
    this._data.sajtInvoiceService = sajtInvoiceService
  }
  get invoiceTitle() {
    return this._data.invoiceTitle
  }
  set invoiceTitle(invoiceTitle) {
    this._data.invoiceTitle = invoiceTitle
  }
  get invoiceAddress() {
    return this._data.invoiceAddress
  }
  set invoiceAddress(invoiceAddress) {
    this._data.invoiceAddress = invoiceAddress
  }
  get agreeTenantBooking() {
    return this._data.agreeTenantBooking
  }
  set agreeTenantBooking(agreeTenantBooking) {
    this._data.agreeTenantBooking = agreeTenantBooking || false
  }
  get userNameEi() {
    return this._data.userNameEi
  }
  set userNameEi(userNameEi) {
    this._data.userNameEi = userNameEi
  }
  get passWordEi() {
    return this._data.passWordEi
  }
  set passWordEi(passWordEi) {
    this._data.passWordEi = passWordEi
  }
  get taxPayerIdEi() {
    return this._data.taxPayerIdEi
  }
  set taxPayerIdEi(taxPayerIdEi) {
    this._data.taxPayerIdEi = taxPayerIdEi
  }
  get authorizationCodeEi() {
    return this._data.authorizationCodeEi
  }
  set authorizationCodeEi(authorizationCodeEi) {
    this._data.authorizationCodeEi = authorizationCodeEi
  }
  get invoiceServiceEi() {
    return this._data.invoiceServiceEi
  }
  set invoiceServiceEi(invoiceServiceEi) {
    this._data.invoiceServiceEi = invoiceServiceEi
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  get parentBranchUuid() {
    return this._data.parentBranchUuid
  }
  set parentBranchUuid(parentBranchUuid) {
    this._data.parentBranchUuid = parentBranchUuid
  }
  get depositBankAccount() {
    return this._data.depositBankAccount
  }
  set depositBankAccount(depositBankAccount) {
    this._data.depositBankAccount = depositBankAccount
  }
  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level || 0
  }
  get whtTaxMode() {
    return this._data.whtTaxMode
  }
  set whtTaxMode(whtTaxMode) {
    this._data.whtTaxMode = whtTaxMode || false
  }
  get multiTitleBankMode() {
    return this._data.multiTitleBankMode
  }
  set multiTitleBankMode(multiTitleBankMode) {
    this._data.multiTitleBankMode = multiTitleBankMode || false
  }
  get invoiceChannel() {
    return this._data.invoiceChannel
  }
  set invoiceChannel(invoiceChannel) {
    this._data.invoiceChannel = invoiceChannel || 0
  }
  get appKey() {
    return this._data.appKey
  }
  set appKey(appKey) {
    this._data.appKey = appKey
  }
  get appSecret() {
    return this._data.appSecret
  }
  set appSecret(appSecret) {
    this._data.appSecret = appSecret
  }
  get token() {
    return this._data.token
  }
  set token(token) {
    this._data.token = token
  }
  get invoicerConfig() {
    return this._data.invoicerConfig
  }
  set invoicerConfig(invoicerConfig) {
    this._data.invoicerConfig = invoicerConfig || 0
  }
  get customField1() {
    return this._data.customField1
  }
  set customField1(customField1) {
    this._data.customField1 = customField1
  }
  get customField2() {
    return this._data.customField2
  }
  set customField2(customField2) {
    this._data.customField2 = customField2
  }
  get customField3() {
    return this._data.customField3
  }
  set customField3(customField3) {
    this._data.customField3 = customField3
  }
  static async getOfficeByUuid(uuid) {
    await cache.load(cacheName.OFFICE_LIST)
    const arr = cache.officeList.filter(p => p.uuid === uuid)
    // cache.officeList 是当前登录用户所属分公司,会选择的其他分公司销售单证等
    let office = arr.length > 0 ? arr[0] : null
    if (!office) {
      await getOfficeByUuid(uuid).then(res => { office = res.data })
    }
    return office
  }
  static async getOfficeById(officeId) {
    // cache.officeList 是当前登录用户所属分公司,会选择的其他分公司销售单证等
    let office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', officeId)
    if (!office) {
      await getOfficeById(officeId).then(res => { office = res.data })
    }
    return office
  }
  // 是否包含HQ
  static hasHq() {
    const officeList = getUserInfo().currentUserOfficeList
    if (officeList.length > 0) {
      return officeList.find(item => {
        return item.code === 'HQ'
      })
    }
    return false
  }
}
